import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { toast } from "react-toastify";
import { api } from "../../api";

interface ChangeImageDialogProps {
  onClose: () => void;
}

@observer
export class ChangeImageDialog extends React.Component<ChangeImageDialogProps, any>
{

  obs = observable({
    focusDone: false as boolean,
    currentPassword: "" as string,
    newPassword: "" as string,
    working: false as boolean,
    nome_certificado: "" as string,
    certificado: [] as any

  })
  focusFirst(el: HTMLInputElement) {
    if (!this.obs.focusDone) {
      el.focus();
      this.obs.focusDone = true;
    }
  }

  uploadFile = (file: any) => {
    this.setState({ nome_certificado: file.target.value });
    this.setState({ certificado: file.target.files });
  };

  closeChangeImage = () => {
    window.location.reload();
  };

  doSaveFile = async () => {
    var certificado = this.state.certificado;
    var input = certificado;
    var data = new FormData();

    data.append("file", input[0]);

    let resp = await api.post("/api/upload-image", data)

    if (resp.data == "Ok") {
      toast.success('Imagem alterada com sucesso.', {});

      setInterval(this.closeChangeImage, 2000);
    }

  };

  render() {

    return (
      <Dialog
        isOpen
        title="Editar Imagem de Perfil"
        onClose={this.props.onClose}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup
            label="Selecione a imagem (.jpg ou .png)"
            labelFor="imagem"
          >
            <input
              type="file"
              id="Imagem"
              className="CertificadoFile"
              name="file"
              onChange={this.uploadFile}
            />
          </FormGroup>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Salvar"
              intent="primary"
              onClick={this.doSaveFile}
              loading={this.obs.working}
            />
            <Button
              text="Cancelar"
              onClick={this.props.onClose}
              disabled={this.obs.working}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}
